export enum BankEntryStatus {
	All = 'All',
	Uncleared = 'Uncleared',
	Cleared = 'Cleared',
	Voided = 'Voided',
}
